// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"76c4118c","787":"d163790c"}[chunkId] + ".chunk.js";
};